import { CurrencyPicker } from 'pricing-pages-ui-components/currency-picker/CurrencyPicker';
import { useHistory, useLocation } from 'quartz-routing/react-router';
import { CURRENCY_PARAM, useCurrency } from '../context/CurrencyContext';
import { isCurrencyCodeString } from '../utils/currencyTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const PublicCurrencyPicker = () => {
  const {
    availableCurrencyCodes,
    displayedCurrencyCode
  } = useCurrency();
  const history = useHistory();
  const location = useLocation();
  const handleChange = event => {
    const value = event.target.value;
    if (!isCurrencyCodeString(value)) return;
    const params = new URLSearchParams(location.search);
    params.set(CURRENCY_PARAM, value);
    history.replace({
      pathname: location.pathname,
      search: params.toString()
    });
  };
  return /*#__PURE__*/_jsx(CurrencyPicker, {
    availableCurrencies: availableCurrencyCodes,
    selectedCurrency: displayedCurrencyCode,
    onChange: handleChange
  });
};
export default PublicCurrencyPicker;